import { createStore, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { rootReducer } from './rootReducer'

export function configStore() {
  const middlewares = [thunkMiddleware]
  const middlewareEnhancer = applyMiddleware(...middlewares)

  /** @type {import('redux').Store} */
  let store

  if (process.env.NODE_ENV !== 'production') {
    const { composeWithDevTools } = require('redux-devtools-extension')
    const { name } = require('../../package.json')

    store = createStore(rootReducer, composeWithDevTools({ name })(middlewareEnhancer))
  } else {
    store = createStore(rootReducer, middlewareEnhancer)
  }

  // if (module['hot']) {
  //   module['hot'].accept('./rootReducer', () => {
  //     store.replaceReducer(rootReducer)
  //   })
  // }

  return store
}
